import { LANGUAGES } from "@/lib/mock-data";
import { useI18n } from "@/lib/i18n";
import { useSeo } from "@/hooks/useSeo";
import { truncate } from "@/lib/seo";



function LanguagesPage() {
  const { locale, t } = useI18n();

  useSeo({
    title: `${t("languages.heading")} — Ramba News`,
    description: truncate(t("languages.description")),
    path: "/languages",
  });

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-10 md:py-14">
      <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-verified">{t("nav.languages")}</div>
      <h1 className="mt-2 font-serif text-3xl md:text-5xl font-semibold tracking-tight">{t("languages.heading")}</h1>
      <p className="mt-4 max-w-2xl text-lg text-muted-foreground leading-relaxed">
        {t("languages.description")}
      </p>

      <ul className="mt-10 grid gap-4 md:grid-cols-2">
        {LANGUAGES.map((l) => (
          <li key={l.code} className="flex items-center gap-4 rounded-md border border-border bg-card p-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-foreground text-background font-mono text-sm font-bold uppercase">
              {l.code}
            </div>
            <div>
              <div className="text-base font-semibold">{locale === "fr" ? l.fr : l.en}</div>
              <div className="text-xs text-muted-foreground">{t("languages.content")}</div>
            </div>
          </li>
        ))}
      </ul>

      <p className="mt-10 text-sm text-muted-foreground">
        {t("languages.note")}
      </p>
    </div>
  );
}

export default LanguagesPage;
